// extracted by mini-css-extract-plugin
export default {"root":"Producer_root__4QzWn","recentMessage":"Producer_recentMessage__8OFKe","line":"Producer_line__H1O3F"};